<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('bold')
})

const onToggleBold = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleBold().run()
}
</script>

<template>
    <button
        @click="onToggleBold"
        :disabled="!editor.can().chain().focus().toggleBold().run()"
        :class="
            clsx(
                'action-bold',
                isDark ? 'dark' : 'light',
                isActive ? 'is-active' : 'is-deactive'
            )
        "
    >
        <span class="sr-only">Bold</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.5 12V19H14.5875C16.4722 19 18 17.433 18 15.5C18 13.567 16.4722 12 14.5875 12H7.5ZM7.5 12H13.5375C15.4222 12 16.95 10.433 16.95 8.5C16.95 6.567 15.4222 5 13.5375 5H7.5V12Z"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-bold.light svg {
    @apply stroke-[#060606];
}

.action-bold.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-bold.is-deactive svg {
    @apply opacity-60;
}

.action-bold.is-active svg {
    @apply opacity-100;
}
</style>
